import React from "react";
import PropTypes from "prop-types";
import styles from "./primarybutton.module.css";

const PrimaryButton = ({
  text,
  onClick = () => {},
  type = "button",
  ...props
}) => {
  return (
    <button
      className={`col-8 ${styles.primaryButton}`}
      onClick={onClick}
      type={type}
      {...props}
    >
      {text}
    </button>
  );
};

PrimaryButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.string,
};

export default PrimaryButton;
